import React from "react";

import { IgTypography } from "@intelligems/ig-theme";

export interface DateRenderProps {
  date: string | null;
}

const emptyString = "-------";

export const DateRender = ({ date }: DateRenderProps) => {
  if (date) {
    return <IgTypography sx={{ fontSize: "15px" }}>{date}</IgTypography>;
  }
  return <IgTypography>{emptyString}</IgTypography>;
};
